import React from 'react'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import TimeSelect from '../../../../../components/form/TimeSelect'
import FormItem from '../../../../../components/form/FormItem'
import SectionsSeparator from './SectionsSeparator'

const AutomaticDistributionSection = () => {
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()
  const canUseAutomaticDistribution = useSessionPermission('useAutomaticDistribution')
  const { t } = useTranslation('editChecklist')

  const commonProps = { handleChange, form, t }

  if (!canUseAutomaticDistribution) return null

  return (
    <>
      <SectionsSeparator />
      <FlexCol paddingGutter={1} width="70%">
        <FormItem label={t('fieldsStep.setRuntime')} field="usages" {...commonProps}>
          <TimeSelect inMinutes value={form.runtime} onChange={value => handleChange('runtime', value)} />
        </FormItem>
      </FlexCol>
    </>
  )
}

export default AutomaticDistributionSection
